// extracted by mini-css-extract-plugin
module.exports = {"period":"styles_period__1FIVm"};